import Button from "../../../shared/components/Button";
import type { TournamentOperationCategory } from "../utils/tournamentOperations";

type PanelTab = "brackets" | "timeline";

type AdminTournamentOperationsHeaderProps = {
  categories: TournamentOperationCategory[];
  categoryKey: string;
  onSelectCategory: (categoryKey: string) => void;
  onSelectTab: (tab: PanelTab) => void;
  tab: PanelTab;
};

export default function AdminTournamentOperationsHeader({
  categories,
  categoryKey,
  onSelectCategory,
  onSelectTab,
  tab,
}: AdminTournamentOperationsHeaderProps) {
  return (
    <>
      <div className="status-filter-buttons admin-tournament-ops-tabs">
        <Button
          type="button"
          variant="pill"
          className={tab === "brackets" ? "active" : ""}
          onClick={() => onSelectTab("brackets")}
        >
          Chaves
        </Button>
        <Button
          type="button"
          variant="pill"
          className={tab === "timeline" ? "active" : ""}
          onClick={() => onSelectTab("timeline")}
        >
          Timeline
        </Button>
      </div>

      {tab !== "timeline" && (
        <label className="field admin-tournament-ops-category">
          <span>Categoria das chaves</span>
          <select
            value={categoryKey}
            onChange={(event) => onSelectCategory(event.target.value)}
          >
            {categories.map((category) => (
              <option key={category.categoryKey} value={category.categoryKey}>
                {category.categoryName}
              </option>
            ))}
          </select>
        </label>
      )}
    </>
  );
}
